import React from 'react';
import PropTypes from 'prop-types';
import useTheme from '@material-ui/core/styles/useTheme';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import makeStyles from '@material-ui/core/styles/makeStyles';
import {Swiper, SwiperSlide} from 'swiper/react';
import SwiperCore, {Navigation, Pagination} from 'swiper';

import 'swiper/swiper.scss';
import 'swiper/components/navigation/navigation.scss';
import 'swiper/components/pagination/pagination.min.css'

SwiperCore.use([Navigation, Pagination]);

const useStyles = makeStyles({
  root: {
    '& .swiper-button-prev, & .swiper-button-next': {
      width: 40,
      height: 40,
      borderRadius: 500,
      backgroundColor: '#fff',
      boxShadow: '0px 0px 10px 0px rgba(189,189,189,1)',
      '&:after': {
        fontSize: 16,
        textTransform: 'none !important',
        letterSpacing: 0,
        fontVariant: 'initial',
        lineHeight: 1,
      },
    },
    '& .swiper-pagination.swiper-pagination-bullets': {
      bottom: '-6px',
    '& span.swiper-pagination-bullet.swiper-pagination-bullet-active':{
      background: '#ef1719',
    },
  },
  '& .swiper-container': {
    paddingBottom: 20,
  },
  },
});

LayoutListHorizontal.propTypes = {
  small: PropTypes.bool,
  data: PropTypes.arrayOf(PropTypes.any).isRequired,
  itemRender: PropTypes.elementType.isRequired,
  maxSlidesPerView: PropTypes.number,
};

export default function LayoutListHorizontal({small, data, itemRender, maxSlidesPerView = 5}) {
  const classes = useStyles();
  const theme = useTheme();
  const isMobil = useMediaQuery('(max-width:767px)');

  if (!data.length) {
    return <div />;
  }

  return (
    <div className={classes.root} style={{marginTop: 15, marginBottom: 15}}>
      <Swiper
        key={isMobil ? 'm' : 'd'}
        // {...(isMobil ? {} : {navigation: false})}
        spaceBetween={theme.spacing(1)}
        slidesPerView={isMobil ? 2 : 4}
        {...(!isMobil ? {} : {pagination: true})}
      >
        {data
          .filter((_, i) => i < 10)
          .map((itemData, i) => (
            <SwiperSlide key={i}>{React.createElement(itemRender, {small, data: itemData})}</SwiperSlide>
          ))}
      </Swiper>
    </div>
  );
}
